export const SITE_CONFIG = {
  name: 'Mahin Utsman Nawawi, S.H, C.D.M.P',
  title: 'Developer No-Code & AI Prompt Specialist',
  tagline: 'Law & Tech in Harmony – Dari Pasal ke Pixel',
  description: 'Lawyer yang beralih ke dunia teknologi. Spesialisasi dalam No-Code Development, AI Prompting, dan Digital Marketing.',
  adminEmail: 'nawawimahinutsman@gmail.com',
};

export const SOCIAL_LINKS = {
  whatsapp: 'https://wa.me/6281320442174',
  whatsappDirect: 'https://wa.me/message/NVNGAA6ZQVU5H1',
  linkedin: 'https://www.linkedin.com/in/mahin-utsman-nawawi-s-h-c-d-m-p-3b4758379?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  tiktok: 'https://www.tiktok.com/@velora002?_r=1&_t=zs-916hsdm10p0',
  github: 'https://github.com/Mahin-Utsman-Nawawi',
  instagram: 'https://www.instagram.com/mahinutsmannawawi.sh?igsh=MWY4OTVva2d2ZHJ5dw==',
};

export const TECH_STACK = [
  'React', 'Next.js', 'TypeScript', 'TailwindCSS', 
  'Node.js', 'Supabase', 'PostgreSQL', 'MongoDB',
  'Bubble.io', 'Webflow', 'Zapier', 'Make.com',
  'ChatGPT', 'Claude', 'Midjourney', 'Stable Diffusion',
];

export const AI_TOOLS = [
  'ChatGPT-4', 'Claude AI', 'Midjourney', 'Stable Diffusion',
  'Runway ML', 'Synthesia', 'Copy.ai', 'Jasper',
];

export const SKILLS_DATA = {
  languages: [
    { name: 'JavaScript', level: 90 },
    { name: 'TypeScript', level: 85 },
    { name: 'Python', level: 75 },
    { name: 'SQL', level: 80 },
  ],
  frameworks: [
    { name: 'React', level: 90 },
    { name: 'Next.js', level: 85 },
    { name: 'Node.js', level: 80 },
    { name: 'TailwindCSS', level: 95 },
  ],
  aiBuilders: [
    { name: 'ChatGPT', level: 95 },
    { name: 'Claude AI', level: 90 },
    { name: 'Midjourney', level: 85 },
    { name: 'Stable Diffusion', level: 80 },
  ],
  databases: [
    { name: 'PostgreSQL', level: 85 },
    { name: 'MongoDB', level: 80 },
    { name: 'Supabase', level: 90 },
    { name: 'Firebase', level: 75 },
  ],
  marketing: [
    { name: 'SEO', level: 85 },
    { name: 'Google Ads', level: 80 },
    { name: 'Facebook Ads', level: 80 },
    { name: 'Content Marketing', level: 90 },
  ],
};

export const CATEGORIES = {
  all: 'Semua',
  web: 'Web',
  'no-code': 'No-Code',
  ai: 'AI',
  'law-tech': 'Law-Tech',
  web3: 'Web3',
};
